import type { FlowInProgress } from "@redotech/redo-flows-common/flow-in-progress";
import type { RecognizeFlowStep } from "@redotech/redo-recognize-actions-common/actions-flow";
import { createContext, type ComponentType } from "react";

export type RecognizeActionsEditorProps = { steps: RecognizeFlowStep[] } & (
  | { readonly: true }
  | {
      readonly?: false;
      versionLabel: string;
      onHistoryClick: () => void;
      onSettingsClick: () => void;
      onSave: (flow: FlowInProgress) => Promise<void>;
    }
);

export const RecognizeActionsEditorContext = createContext<
  ComponentType<RecognizeActionsEditorProps> | undefined
>(undefined);
